import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../client/components/ui/dialog";
import { Button } from "../../../client/components/ui/button";
import { Label } from "../../../client/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../client/components/ui/select";
import useTranslation from "../../../client/hooks/useTranslation";
import AccountChargesManager from "../../../trading-accounts/AccountChargesManager";
import AccountFinanceDialog from "../../../prop-firm-manager/AccountFinanceDialog";
import { useLiteData } from "../../data/LiteDataProvider";

const GLOBAL = "__global";

/**
 * « Dépense » : réutilise les formulaires de l'app. Sans compte, le gestionnaire
 * de charges globales ; avec un compte, la fenêtre « infos financières » du PFM
 * (prix du challenge, frais d'activation, charges du compte).
 */
export function ExpenseDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const t = useTranslation().lite.pfm.expenseDialog;
  const { accounts, charges, refetchAll } = useLiteData();
  const [scope, setScope] = useState(GLOBAL);
  const [financeId, setFinanceId] = useState<string | null>(null);

  const propAccounts = accounts.filter(a => a.firm).sort((a, b) => Number(!a.active) - Number(!b.active) || a.name.localeCompare(b.name));
  const finance = financeId ? accounts.find(a => a.id === financeId)?.raw ?? null : null;

  return (
    <>
      <Dialog open={open} onOpenChange={o => { if (!o) onClose(); }}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{t.title}</DialogTitle>
            <DialogDescription>{t.description}</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label>{t.scope}</Label>
              <Select value={scope} onValueChange={setScope}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value={GLOBAL}>{t.global}</SelectItem>
                  {propAccounts.map(a => <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            {scope === GLOBAL ? (
              <AccountChargesManager charges={charges.filter(c => !c.accountId).map(c => ({ ...c, accountId: null }))} accountId={null} onMutated={refetchAll} />
            ) : (
              <Button onClick={() => { setFinanceId(scope); onClose(); }}>{t.openAccount}</Button>
            )}
          </div>
        </DialogContent>
      </Dialog>
      {finance && (
        <AccountFinanceDialog
          account={{ id: finance.id, name: finance.name, challengeCost: finance.challengeCost, activationFee: finance.activationFee, payouts: finance.payouts ?? [], propFirmAdjustments: finance.propFirmAdjustments ?? [] }}
          charges={charges.filter(c => c.accountId === finance.id)}
          onClose={() => { setFinanceId(null); refetchAll(); }}
          onChargesMutated={refetchAll}
        />
      )}
    </>
  );
}
